import service from "./service";

const getVendorProducts = ({ page = 1, limit = 10 } = {}) =>
  service.get(
    "vendors/products/vendor-created?page=" +
      encodeURIComponent(page) +
      "&limit=" +
      encodeURIComponent(limit),
  );
const getVendorProduct = (id) =>
  service.get("vendors/products/vendor-created/" + encodeURIComponent(id));
const createVendorProduct = (payload) =>
  service.post("vendors/products/vendor-created", payload);
const updateVendorProduct = (id, payload) =>
  service.put("vendors/products/vendor-created/" + encodeURIComponent(id), payload);
const deleteVendorProduct = (id) =>
  service.deleteApi("vendors/products/vendor-created/" + encodeURIComponent(id));
const getSectors = () => service.get("clients/sectors");
const getSectorProducts = (sectorId) =>
  service.get("clients/products?sector=" + encodeURIComponent(sectorId));

const vendorProductApi = {
  getVendorProducts,
  getVendorProduct,
  createVendorProduct,
  updateVendorProduct,
  deleteVendorProduct,
  getSectors,
  getSectorProducts,
};
export default vendorProductApi;
